import { Chip } from "@mui/material";

export type StatusCalculo = "error" | "warning" | "info" | "success";

/** Cada estado do fechamento mapeia para UMA das cinco cores semânticas de
 *  chip do sistema (DESIGN.md → Chips de status). Não existe a sexta. */
const MAPA: Record<
  StatusCalculo,
  { tom: "positive" | "warn" | "destructive" | "accent"; rotulo: string }
> = {
  success: { tom: "positive", rotulo: "Em dia" },
  warning: { tom: "warn", rotulo: "Desatualizado" },
  error: { tom: "destructive", rotulo: "Sem cálculo" },
  info: { tom: "accent", rotulo: "Em processamento" },
};

type Props = {
  status: StatusCalculo;
};

export default function StatusCalculoChip({ status }: Props) {
  const { tom, rotulo } = MAPA[status];
  return (
    <Chip
      size="small"
      label={rotulo}
      sx={(theme) => ({
        backgroundColor: theme.palette.statusChip[tom].bg,
        color: theme.palette.statusChip[tom].fg,
      })}
    />
  );
}
